import { jsx as _jsx } from "preact/jsx-runtime";
import IconCloseTiny from '@fandom-frontend/react-common/dist/icons/IconCloseTiny';
import styles from './QuizModalCloseButton.module.scss';
const QuizModalCloseButton = ({ onClick }) => (_jsx(IconCloseTiny, { onClick: onClick, className: styles.closeButton }, void 0));
export default QuizModalCloseButton;
